import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import style from './style.module.scss';

const AppFooter: React.FC = (): React.ReactElement => {
  const currentYear: number = new Date().getFullYear();
  const navigate = useNavigate();

  const handleLinkClick = (e: React.MouseEvent, path: string) => {
    if (path.startsWith('http') || path.startsWith('mailto')) return;
    e.preventDefault();
    navigate(path);
  };

  return (
    <Box
      component="footer"
      className={style.footer}
      sx={{
        bgcolor: '#1f2a63', // navy background
        color: 'white', // white text
        py: 4,
      }}
    >
      <Container maxWidth="lg" className={style.footerContent}>
        <Typography variant="body2" align="center" gutterBottom color="inherit">
          © {currentYear} Planoo — Helping Australians plan their next move
          smarter.
        </Typography>

        <Box
          className={style.footerLinks}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          <Link
            href="/"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/')}
          >
            Home
          </Link>
          <span>·</span>
          <Link
            href="/about"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/about')}
          >
            About
          </Link>
          <span>·</span>
          <Link
            href="/how-it-works"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/how-it-works')}
          >
            How it Works
          </Link>
          <span>·</span>
          <Link
            href="/contact"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/contact')}
          >
            Contact
          </Link>
        </Box>

        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 2 }}
          color="inherit"
        >
          Feedback?{' '}
          <Link href="mailto:info@planoo.com.au" color="inherit">
            info@planoo.com.au
          </Link>
        </Typography>

        <Box
          className={style.footerLinks}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            mt: 1,
            flexWrap: 'wrap',
          }}
        >
          <Link
            href="/about#privacy-policy"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/about#privacy-policy')}
          >
            Privacy Policy
          </Link>
          <span>·</span>
          <Link
            href="/about#terms-of-use"
            color="inherit"
            underline="hover"
            onClick={(e) => handleLinkClick(e, '/about#terms-of-use')}
          >
            Terms of Use
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default AppFooter;
